import React, { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import AuthEntryLayout from 'layouts/AuthEntryLayout/AuthEntryLayout';
import entryStyles from 'layouts/AuthEntryLayout/AuthEntryLayout.module.scss';

import { AuthInfo, PasswordRecoveryData } from 'types';
import ROUTES from 'constants/routes';
import { useAppDispatch } from 'store';
import { recoverPasswordAction } from 'store/auth/auth.reducer';
import { PhoneConfirmation } from 'containers/PhoneConfirmation/PhoneConfirmation';
import { PasswordRecoveryForm } from './components/PasswordRecoveryForm/PasswordRecoveryForm';

interface Props {
  onFinish: (data: AuthInfo) => void;
}

export const PhoneVerification: FC<Props> = ({ onFinish }) => {
  const dispatch = useAppDispatch();

  const [confirmToken, setConfirmToken] = useState<string>('');

  const handlePasswordRecover = async (data: PasswordRecoveryData) => {
    const { token } = await dispatch(recoverPasswordAction(data));
    setConfirmToken(token);
  };

  return (
    <AuthEntryLayout title="Восстановление пароля">
      {!confirmToken ? (
        <PasswordRecoveryForm onSubmit={handlePasswordRecover} />
      ) : (
        <PhoneConfirmation
          type={ROUTES.PASSWORD_RECOVERY}
          confirmToken={confirmToken}
          onFinish={onFinish}
          onResend={setConfirmToken}
          appearance="login"
        />
      )}
      <div className={entryStyles.forgotPassword}>
        <Link to={ROUTES.LOGIN}>← Вернуться</Link>
      </div>
    </AuthEntryLayout>
  );
};
